const parseHomepageUrl = homepageUrl => {
    if (homepageUrl.startsWith('www.')) {
        return homepageUrl.split('www.')[1];
    }
    return homepageUrl;
};
const getRevenueRangeString = revenueRange => {
    const { min, max } = revenueRange;
    let revenueString = '';
    if (min && max) {
        revenueString = `${revenueFormatter(min)} to ${revenueFormatter(max)}`;
    }
    else if (min || max) {
        revenueString = revenueFormatter(min || max);
    }
    return revenueString;
};
const revenueFormatter = num => {
    if (num < 1000) {
        return num;
    }
    if (num >= 1000 && num < 1000000) {
        return `$${Math.trunc(num / 1000)}K`;
    }
    if (num >= 1000000 && num < 1000000000) {
        return `$${Math.trunc(num / 1000000)}M`;
    }
    if (num >= 1000000000 && num < 10000000000) {
        return `$${Math.trunc(num / 1000000000)}B`;
    }
    if (num >= 10000000000 && num < 100000000000) {
        return `$${Math.trunc(num / 10000000000)}0B`;
    }
    if (num >= 100000000000 && num < 1000000000000) {
        return `$${Math.trunc(num / 100000000000)}00B`;
    }
    if (num >= 1000000000000) {
        return '$100B+';
    }
    return '';
};
module.exports = {
    parseHomepageUrl,
    getRevenueRangeString,
};
